import { auth } from '../firebaseConfig';

const API_BASE = '/api/screenshots';

const JSON_HEADERS = { 'Accept': 'application/json' };

const HETZNER_ORIGIN = 'http://46.225.235.77';

const rewriteImageUrls = (items) => {
    if (!Array.isArray(items)) return items;
    return items.map(item => {
        if (item.supabase_storage_url && item.supabase_storage_url.startsWith(HETZNER_ORIGIN)) {
            return { ...item, supabase_storage_url: item.supabase_storage_url.replace(HETZNER_ORIGIN, '') };
        }
        return item;
    });
};

export async function fetchScreenshots({
    filters = {},
    search = '',
    orderBy = 'quality_score',
    ascending = false,
    offset = 0,
    limit = 16,
} = {}) {
    const params = new URLSearchParams();

    const eqFields = [
        'scene_type', 'content_type', 'lighting_type',
        'time_of_day', 'dominant_color', 'bokeh_strength',
    ];
    const gteFields = ['quality_score', 'emotion_score', 'composition_score'];

    eqFields.forEach(key => {
        if (filters[key]) params.append(key, `eq.${filters[key]}`);
    });

    gteFields.forEach(key => {
        if (filters[key] > 0) params.append(key, `gte.${filters[key]}`);
    });

    if (filters.face_visible) {
        params.append('face_visible', `is.${filters.face_visible}`);
    }

    if (search) {
        params.append('description', `ilike.*${search}*`);
    }

    params.append('order', `${orderBy}.${ascending ? 'asc' : 'desc'}`);
    params.append('offset', String(offset));
    params.append('limit', String(limit));

    const response = await fetch(`${API_BASE}?${params.toString()}`, {
        headers: { ...JSON_HEADERS, 'Prefer': 'count=exact' },
    });
    if (!response.ok) throw new Error(`API error: ${response.status}`);

    const data = await response.json();
    const range = response.headers.get('Content-Range');
    const total = range ? parseInt(range.split('/')[1], 10) : data.length;

    return { data: rewriteImageUrls(data), total };
}

export async function fetchScreenshotsByIds(ids, fields = []) {
    if (!ids || ids.length === 0) return [];

    const params = new URLSearchParams();
    params.append('id', `in.(${ids.join(',')})`);
    if (fields.length > 0) params.append('select', fields.join(','));

    const response = await fetch(`${API_BASE}?${params.toString()}`, {
        headers: JSON_HEADERS,
    });
    if (!response.ok) throw new Error(`API error: ${response.status}`);

    const data = await response.json();
    return rewriteImageUrls(data);
}

export async function updateScreenshot(id, data) {
    const params = new URLSearchParams();
    params.append('id', `eq.${id}`);

    // Writes go through the proxy, which requires an authenticated caller.
    const token = await auth.currentUser?.getIdToken();
    if (!token) throw new Error('Sign in required to update a screenshot');

    const response = await fetch(`${API_BASE}?${params.toString()}`, {
        method: 'PATCH',
        headers: {
            ...JSON_HEADERS,
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`API error: ${response.status}`);
    return response.json();
}
